/* =========================================================
   ASTRAL'AURA : LE CIEL ÉTOILÉ DE LA BOUTIQUE
   Le même ciel que sur astral-aura.fr : des étoiles qui
   scintillent, bougent avec la souris (effet de profondeur),
   se relient en constellations autour du curseur, et une
   étoile filante de temps en temps.
   Il anime les zones sombres qui encadrent la page :
   le bandeau d'annonce, l'en-tête et le pied de page.
   Tout est dans une fonction "fermée" pour ne jamais gêner
   les scripts de Shopify et du thème.
========================================================= */

(function () {
    // Les zones qui reçoivent un ciel
    const ZONES = [".utility-bar", ".header-wrapper", ".footer"];

    // Le visiteur a-t-il demandé à réduire les animations ?
    const mouvementReduit = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    function creerCiel(zone) {
        zone.classList.add("astral-ciel-zone");
        const canvas = document.createElement("canvas");
        canvas.className = "astral-ciel";
        canvas.setAttribute("aria-hidden", "true");
        zone.prepend(canvas);

        const ctx = canvas.getContext("2d");
        let largeur = 0;
        let hauteur = 0;
        let etoiles = [];
        let filante = null;
        let visible = true;
        const souris = { x: -9999, y: -9999, lisseX: 0, lisseY: 0, dedans: false };

        /* --- Création des étoiles (selon la taille de la zone) --- */
        function redimensionner() {
            const ratio = Math.min(window.devicePixelRatio || 1, 2);
            largeur = zone.offsetWidth;
            hauteur = zone.offsetHeight;
            canvas.width = largeur * ratio;
            canvas.height = hauteur * ratio;
            ctx.setTransform(ratio, 0, 0, ratio, 0, 0);

            const nombre = Math.round((largeur * hauteur) / 4000);
            etoiles = [];
            for (let i = 0; i < nombre; i++) {
                etoiles.push({
                    x: Math.random() * largeur,
                    y: Math.random() * hauteur,
                    profondeur: Math.random(),
                    rayon: Math.random() * 1.1 + 0.3,
                    phase: Math.random() * Math.PI * 2,
                    vitesse: Math.random() * 0.02 + 0.005,
                    doree: Math.random() < 0.18,
                });
            }
            if (mouvementReduit) {
                dessiner(0);
            }
        }

        /* --- Une image de l'animation --- */
        function dessiner(temps) {
            ctx.clearRect(0, 0, largeur, hauteur);

            const cibleX = souris.dedans ? souris.x - largeur / 2 : 0;
            const cibleY = souris.dedans ? souris.y - hauteur / 2 : 0;
            souris.lisseX += (cibleX - souris.lisseX) * 0.05;
            souris.lisseY += (cibleY - souris.lisseY) * 0.05;

            const proches = [];
            etoiles.forEach(function (e) {
                const decalage = e.profondeur * 0.035;
                const x = e.x - souris.lisseX * decalage;
                const y = e.y - souris.lisseY * decalage;
                const eclat = 0.45 + Math.sin(temps * e.vitesse * 0.06 + e.phase) * 0.35;

                ctx.beginPath();
                ctx.arc(x, y, e.rayon * (0.6 + e.profondeur * 0.6), 0, Math.PI * 2);
                ctx.fillStyle = e.doree ? "rgba(217, 191, 143," + eclat + ")" : "rgba(243, 237, 228," + eclat + ")";
                ctx.fill();

                if (souris.dedans && Math.hypot(x - souris.x, y - souris.y) < 140) {
                    proches.push({ x: x, y: y, distance: Math.hypot(x - souris.x, y - souris.y) });
                }
            });

            // Les constellations autour du curseur
            ctx.lineWidth = 0.6;
            for (let i = 0; i < proches.length; i++) {
                for (let j = i + 1; j < proches.length; j++) {
                    const a = proches[i];
                    const b = proches[j];
                    const ecart = Math.hypot(a.x - b.x, a.y - b.y);
                    if (ecart < 70) {
                        const force = (1 - ecart / 70) * (1 - Math.max(a.distance, b.distance) / 140);
                        ctx.strokeStyle = "rgba(217, 191, 143," + force * 0.9 + ")";
                        ctx.beginPath();
                        ctx.moveTo(a.x, a.y);
                        ctx.lineTo(b.x, b.y);
                        ctx.stroke();
                    }
                }
            }

            // L'étoile filante
            if (filante) {
                const traine = ctx.createLinearGradient(
                    filante.x, filante.y,
                    filante.x - filante.vx * 12, filante.y - filante.vy * 12,
                );
                traine.addColorStop(0, "rgba(255, 245, 225," + filante.vie + ")");
                traine.addColorStop(1, "rgba(255, 245, 225, 0)");
                ctx.strokeStyle = traine;
                ctx.lineWidth = 1.2;
                ctx.beginPath();
                ctx.moveTo(filante.x, filante.y);
                ctx.lineTo(filante.x - filante.vx * 12, filante.y - filante.vy * 12);
                ctx.stroke();
                filante.x += filante.vx;
                filante.y += filante.vy;
                filante.vie -= 0.015;
                if (filante.vie <= 0) {
                    filante = null;
                }
            } else if (!mouvementReduit && Math.random() < 0.003) {
                filante = {
                    x: Math.random() * largeur * 0.7,
                    y: Math.random() * hauteur * 0.3,
                    vx: 6 + Math.random() * 4,
                    vy: 1 + Math.random() * 1.5,
                    vie: 1,
                };
            }
        }

        /* --- La boucle (en pause si la zone est hors de l'écran) --- */
        function boucle(temps) {
            if (visible && !document.hidden) {
                dessiner(temps);
            }
            requestAnimationFrame(boucle);
        }

        zone.addEventListener("pointermove", function (event) {
            const rect = zone.getBoundingClientRect();
            souris.x = event.clientX - rect.left;
            souris.y = event.clientY - rect.top;
            souris.dedans = true;
        });
        zone.addEventListener("pointerleave", function () {
            souris.dedans = false;
            souris.x = -9999;
            souris.y = -9999;
        });

        new ResizeObserver(redimensionner).observe(zone);
        new IntersectionObserver(function (entrees) {
            visible = entrees[0].isIntersecting;
        }).observe(zone);

        redimensionner();
        if (!mouvementReduit) {
            requestAnimationFrame(boucle);
        }
    }

    ZONES.forEach(function (selecteur) {
        document.querySelectorAll(selecteur).forEach(creerCiel);
    });
})();
